import * as yup from 'yup'
import { transformStringDateFormatToDate } from '../../shared/lib/helpers/transformStringDateFormatToDate'

export const EquipmentEditCreateSchema = yup.object().shape({
	dicts: yup.array().of(
		yup.object().shape({
			name: yup.string().required({ key: 'required' }).nullable(),
			commissioningDate: yup.string().required({ key: 'required' }).nullable(),
			serviceLife: yup.string().when('isIndefinitely', {
				is: true,
				then: yup.string().notRequired().nullable(),
				otherwise: yup.string().required({ key: 'required' }).nullable(),
			}),
			isWithinServiceLife: yup.string().required({ key: 'required' }).nullable(),
			inventoryNumber: yup.string().required({ key: 'required' }).nullable(),
		})
	),
})

export const PPMEquipmentEditCreateSchema = yup.object().shape({
	dicts: yup.array().of(
		yup.object().shape({
			nameKz: yup.string().required({ key: 'required' }),
			nameRu: yup.string().required({ key: 'required' }),
			issueRateCode: yup.string().required({ key: 'required' }),
			normativDocument: yup.string().required({ key: 'required' }),
			isCert: yup.string().required({ key: 'required' }),
			isCompliantWithStandards: yup.string().required({ key: 'required' }),
		})
	),
})

export const Step3Schema = yup.object().shape({
	plannedDays: yup.number().required({ key: 'required' }).nullable(true),
	totalServiceCost: yup.number().required({ key: 'required' }).nullable(true),
})

export const ContractSpecializedSchema = yup.object().shape({
	binSO: yup.string().required({ key: 'required' }).nullable(true),
	contractNumber: yup.string().required({ key: 'required' }).nullable(true),
	contractSum: yup.string().required({ key: 'required' }).nullable(true),
	contractDate: transformStringDateFormatToDate().required({ key: 'required' }),
	beginDate: transformStringDateFormatToDate().required({ key: 'required' }),
	endDate: transformStringDateFormatToDate().required({ key: 'required' }),
})

export const Step1AdditionalAddressSchema = yup.object().shape({
	ddistrictCode: yup
		.string()
		.when('dcountryCode', {
			is: (dcountryCode) => Number(dcountryCode) === 398,
			then: yup.string().required({ key: 'required' }).nullable(),
		})
		.nullable(),
	dregionCode: yup
		.string()
		.when('dcountryCode', {
			is: (dcountryCode) => Number(dcountryCode) === 398,
			then: yup.string().required({ key: 'required' }).nullable(),
		})
		.nullable(),
	dlocalityCode: yup
		.string()
		.nullable()
		.when(['dcountryCode', 'dremoteWorkCode'], {
			is: (dcountryCode, dremoteWorkCode) => Number(dcountryCode) === 398 || Number(dremoteWorkCode) === 1,
			then: yup
				.string()
				.nullable()
				.test(
					'undefined-or-non-empty-string',
					{ key: 'required' },
					(value) => value === undefined || (typeof value === 'string' && value.trim().length > 0)
				),
			otherwise: yup
				.string()
				.nullable()
				.test('not-null', { key: 'required' }, (value) => value !== null),
		}),
	addressKz: yup.string().required({ key: 'required' }).nullable(),
	address: yup.string().required({ key: 'required' }).nullable(),
})

export const Step1AdditionalOkedSchema = yup.object().shape({
	okedCode: yup.string().required({ key: 'required' }).nullable(),
})
